import fetchHelper from './fetch-helper';

export const createActionType = actionType => ({
  START: `${actionType}_START`,
  SUCCESS: `${actionType}_SUCCESS`,
  ERROR: `${actionType}_ERROR`,
});

export const createAction = ACTION_TYPE => ({
  start: data => ({
    type: ACTION_TYPE.START,
    data,
  }),
  success: (data, params, body, reduxState) => ({
    type: ACTION_TYPE.SUCCESS,
    data,
    params, // query string in GET request
    body, // body in POST request
    reduxState,
  }),
  error: data => ({
    type: ACTION_TYPE.ERROR,
    data,
  }),
});

export const createFetchAction = (
  ACTION_TYPE,
  endpoint,
  option,
  callback,
  authType,
) => {
  const action = createAction(ACTION_TYPE);
  return fetchHelper(endpoint, action, option, callback, authType);
};
